var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable),expression:"enable"}],attrs:{"id":"canvas-zone"},on:{"dragover":_vm.dragover,"drop":_vm.drop}},[_c('canvas',{ref:"canvas",attrs:{"id":"unity-canvas","tabindex":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }